import { render, staticRenderFns } from "./PreferencesCard.vue?vue&type=template&id=0f91a132&"
import script from "./PreferencesCard.vue?vue&type=script&lang=js&"
export * from "./PreferencesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports